<template>
  <div
    class="insights-performance-highlights-card"
    :class="{ 'insights-performance-highlights-card-hovered': isHovered }"
  >
    <section class="header">
      <AppAvatarInitial
        v-if="highlightsData.type === 'user'"
        :text="highlightsData.name"
        size="speck"
      />
      <div
        v-else
        class="team-badge"
      >
        team
      </div>
      <a
        class="team-member-name"
        @click="onNameClick"
      >
        {{ highlightsData.name }}
      </a>
      <div
        v-if="totalHighlights > 1"
        class="card-pagination"
      >
        <div
          class="card-pagination-arrow-wrapper"
          @click.stop="slide('prev')"
          @touchstart.stop
          @touchend.stop
          @mousedown.stop
        >
          <img
            id="card-pagination-control-left"
            class="card-pagination-control"
            :src="ICON_ARROW_CONTROL_LEFT"
            alt="carousel right control"
          />
        </div>
        <span class="card-pagination-count">{{ activeHighlight }}/{{ totalHighlights }}</span>
        <div
          class="card-pagination-arrow-wrapper"
          @click.stop="slide('next')"
          @touchstart.stop
          @touchend.stop
          @mousedown.stop
        >
          <img
            id="card-pagination-control-right"
            class="card-pagination-control"
            :src="ICON_ARROW_CONTROL_RIGHT"
            alt="carousel right control"
          />
        </div>
      </div>
    </section>
    <section class="body">
      <transition :name="`slide-fade-${slideDirection}`">
        <Highlight
          v-if="activeCard"
          :key="activeHighlight"
          :highlight="activeCard"
          :time-frame="timeFrame"
          @hovered="setHovered"
          @open-dialog="openDialog"
        />
      </transition>
    </section>
  </div>
</template>

<script>
import AppAvatarInitial from '~/components/AppAvatarInitial.vue';
import { ICON_ARROW_CONTROL_LEFT, ICON_ARROW_CONTROL_RIGHT } from '~/rails_assets';
import Highlight from './InsightsPerformanceHighlightsHighlight.vue';

export default {
  name: 'InsightsPerformanceHighlightsCard',
  components: {
    AppAvatarInitial,
    Highlight,
  },
  props: {
    highlightsData: {
      type: Object,
      required: true,
    },
    timeFrame: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    activeHighlight: 1,
    totalHighlights: 10,
    isHovered: false,
    slideDirection: 'next',
    ICON_ARROW_CONTROL_LEFT,
    ICON_ARROW_CONTROL_RIGHT,
  }),
  computed: {
    filteredCards() {
      return this.highlightsData.cards.filter((card) => card.significant);
    },
    activeCard() {
      return this.filteredCards[this.activeHighlight - 1] || null;
    },
  },
  created() {
    this.totalHighlights = this.filteredCards.length;
  },
  methods: {
    slide(direction) {
      if (direction === 'next') {
        this.slideDirection = 'next';
        this.activeHighlight = this.activeHighlight === this.totalHighlights ? 1 : this.activeHighlight + 1;
      } else {
        this.slideDirection = 'prev';
        this.activeHighlight = this.activeHighlight === 1 ? this.totalHighlights : this.activeHighlight - 1;
      }
    },
    setHovered(isHovered) {
      this.isHovered = isHovered;
    },
    openDialog() {
      this.$emit('openDialog', { ...this.highlightsData });
    },
    onNameClick() {
      const { id, type } = this.highlightsData;

      this.$emit('redirectToTeamMember', { id, type });
    },
  },
};
</script>
